module.exports = __webpack_public_path__ + "media/images/samples/1280x768/6-52b7e11d6f24ee801f72c4172d3e9273.jpg";